import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['placeholder', 'resultsContainer']

  hide() {
    leave(this.placeholderTarget)
    if (this.hasResultsContainerTarget) {
      enter(this.resultsContainerTarget)
    }
  }

  show() {
    enter(this.placeholderTarget)
    if (this.hasResultsContainerTarget) {
      leave(this.resultsContainerTarget)
    }
  }
}
